import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';

import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useEffect } from "react";

import droneRender from './assets/drone-render-cut.png';
import droneText1 from './assets/drone-text-1.png'
import droneText2 from './assets/drone-text-2.png'
import droneText3 from './assets/drone-text-3.png'

import droneText1Pl from './assets/drone-text-1-pl.png'
import droneText2Pl from './assets/drone-text-2-pl.png'
import droneText3Pl from './assets/drone-text-3-pl.png'

import { useTranslation } from 'react-i18next'


const boxVariant = {
    visible: { opacity: 1, scale: 1, transition: { duration: 0.8 } },
    hidden: { opacity: 0, scale: 0 }
  };

  const FloatingText = ({ asset, alt, top, left, topsm, topmd, leftsm }) => {
    const control = useAnimation();
    const [ref, inView] = useInView();
  
    useEffect(() => {
      if (inView) {
        control.start("visible");
      } else {
        control.start("hidden");
      }
    }, [control, inView]);
  
    return (
      <Container sx={{
        position: 'absolute',
        mt: {
          xl: top,
          lg: top,
          md: topmd,
          sm: topsm,
          xs: topsm
        },
        ml: {
          xl: left,
          lg: left,
          md: leftsm,
          sm: leftsm,
          xs: leftsm
        },
        maxWidth: {
            xl: '10vw',
            lg: '10vw',
            md: '10vw',
            sm: '15vh',
            xs: '15vh'
        }, 
        '@media (orientation: landscape)': { maxWidth: {
          xl: '10vw',
          lg: '10vw',
          md: '15vw',
          sm: '20vw',
          xs: '20vw'
        }}}} >
        <motion.div
          ref={ref}
          variants={boxVariant}
          initial="hidden"
          animate={control}>
            
          <img style={{ height:'100%', width:'100%' }} src={asset} alt={alt} />
        </motion.div>
      </Container>
    );
  };


export default function DronePage() {
  const { t, i18n } = useTranslation();

    return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
            backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? theme.palette.grey[200]
              : theme.palette.grey[800], 
          }}>

            <Container sx={{ mt: 12, mb: 2, 
            '@media (orientation: portrait)': { mt: 5 },
             maxWidth: {
                xl: 'md',
                lg: 'md',
                md: "md",
                sm: "sm",
                xs: "xs"
            }, }} >

                <Typography variant="h1" component="h1" gutterBottom align="left"
                sx={{
                    maxWidth: {
                        xl: 'md',
                        lg: 'md',
                        md: "md",
                        sm: "sm",
                        xs: "xs"
                    },
                    fontSize: {
                      xl: 100,
                      lg: 100,
                      md: 70,
                      sm: 60,
                      xs: 50
                    }
                }}>
                  { t('drone-title-text')}

                </Typography>
                <Typography variant="h4" align="left" sx={{
                    fontSize: {
                        xl: 35,
                        lg: 35,
                        md: 35,
                        sm: 20,
                        xs: 20
                    }
                }} >
                  {t('drone-main-text')} 
                    </Typography>
            </Container>

            <Container sx={{ mt: 12, mb: 12, position: 'relative',
             maxWidth: {
                xl: 'lg',
                lg: 'md',
                md: "md",
                sm: "sm",
                xs: "xs"
            }, }} >
              <FloatingText asset={i18n.language === 'en' ? droneText1 : droneText1Pl}  alt={t('drone-image-alt-text1')} top={'5%'} left={'-5%'} topmd={'-5%'} topsm={'-10%'} leftsm={'0%'}/> 
              <FloatingText asset={i18n.language === 'en' ? droneText2 : droneText2Pl}  alt={t('drone-image-alt-text2')} top={'0%'} left={'70%'} topmd={'0%'} topsm={'-6%'} leftsm={'55%'}/> 
              <FloatingText asset={i18n.language === 'en' ? droneText3 : droneText3Pl}  alt={t('drone-image-alt-text3')} top={'50%'} left={'5%'} topmd={'58%'} topsm={'55%'} leftsm={'57%'}/> 
              <img style={{ height:'100%', width:'100%' }} src={droneRender} alt={t('drone-image-alt')} />
            </Container>
        </Box>
    );
}